import { AccountActivityI } from "shared/lib/interfaces/account";

export const ACCOUNT_ACTIVITY_TYPES = {
  CALLBACK_BOOKED: "callback_booked",
  BOOKED_MEETING: "booked_meeting",
  CALL_DISPOSITION: "call_disposition",
  CONTACT_ADDED: "contact_added",
  CALLED_BACK: "called_back",
  AE_NOTE: "ae_note",
  CANCEL_MEETING: "cancel_meeting",
  ACCOUNT_DNC: "account_dnc",
  ACCOUNT_UN_DNC: "account_undnc",
  USER_NOTE: "user_note",
  CALL: "call",
  SET_BACKLOG: "set_backlog",
  MARK_TENTATIVE_INTEREST_DONE: "mark_tentative_interest_done",
  SYSTEM_DQ: "system_dq",
  HIDE_CONTACT: "hide_contact",
  DISQUALIFY_LEAD: "disqualify_lead",
  DISQUALIFY: "disqualify",
  UNDISQUALIFY: "undisqualify",
  PHONE_DNC_STATUS_CHANGE: "phone_dnc_status_change",

  // Activity types from catchups
  EMAIL_REQUEST: "email_request",
  EMAIL_SENT: "email_sent",
  EMAIL_RECEIVED: "email_received",
  EMAIL_REQUEST_REJECTED: "email_request_rejected",
  MARK_DONE: "mark_todo_done",
  ARCHIVE: "archive",
  UNARCHIVE: "unarchive",
  SKIP_LEAD: "skip_lead",
  TODO_FOLLOWUP_EMAIL: "todo_follow_up_email",

  COLD_OUTREACH_EMAIL_RESPONDED: "email_cold_outreach_responded",

  SUPPRESSION: "suppression",

  ASSIGN_LEAD: "assign_lead",
} as const;

export const ACCOUNT_ACTIVITY_TYPES_WITHOUT_CONTACT: AccountActivityI[] = [
  ACCOUNT_ACTIVITY_TYPES.CONTACT_ADDED,
  ACCOUNT_ACTIVITY_TYPES.AE_NOTE,
  ACCOUNT_ACTIVITY_TYPES.ACCOUNT_DNC,
  ACCOUNT_ACTIVITY_TYPES.ACCOUNT_UN_DNC,
  ACCOUNT_ACTIVITY_TYPES.USER_NOTE,
  ACCOUNT_ACTIVITY_TYPES.ARCHIVE,
  ACCOUNT_ACTIVITY_TYPES.UNARCHIVE,
];

export const ACCOUNT_STATUSES = {
  BACKLOG: "backlog", //"Backlog" is showcased as "No status" on the UI
  CALLBACK: "callback",
  MEETING_SCHEDULED: "meeting_scheduled",
  FEEDBACK_RECEIVED: "feedback",
  NO_SHOW: "no_show",
  ARCHIVE: "archive",
} as const;

// The new account statuses which were introduced for the maxed dialer and nurturing lists
export const ACCOUNT_DISPOSITION_STATUSES = {
  COLD_LEAD: "cold_lead",
  NURTURE: "nurture",
  MEETING_SCHEDULED: "meeting_scheduled",
  FEEDBACK_RECEIVED: "feedback",
  DISQUALIFIED: "disqualified",
} as const;

export const ACCOUNT_DISPOSITION_STATUS_LABELS = {
  [ACCOUNT_DISPOSITION_STATUSES.COLD_LEAD]: "Cold",
  [ACCOUNT_DISPOSITION_STATUSES.NURTURE]: "Nurture",

  // Feedback is not actually used and added here to avoid TS errors
  [ACCOUNT_DISPOSITION_STATUSES.FEEDBACK_RECEIVED]: "Feedback",

  [ACCOUNT_DISPOSITION_STATUSES.MEETING_SCHEDULED]: "Meeting Scheduled",
  [ACCOUNT_DISPOSITION_STATUSES.DISQUALIFIED]: "Disqualified",
} as const;

export const ACCOUNT_STATUSES_MAP = {
  [ACCOUNT_STATUSES.BACKLOG]: "No Status", //"Backlog" is showcased as "No status" on the UI
  [ACCOUNT_STATUSES.CALLBACK]: "Callback",
  [ACCOUNT_STATUSES.MEETING_SCHEDULED]: "Meeting Scheduled",
  [ACCOUNT_STATUSES.FEEDBACK_RECEIVED]: "Feedback Received",
  [ACCOUNT_STATUSES.NO_SHOW]: "No Show",
  [ACCOUNT_STATUSES.ARCHIVE]: "Archive",
} as const;

export const ACCOUNT_HISTORY_AI_PROCESS_MAP = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  DONE: 2,
} as const;

// TODO remove NO_SHOW from statuses and all side effects connected to it
// THERE IS NO   NO_SHOW    status there is meeting_outcome: "no_show"
export const MEETING_OUTCOMES = {
  CANCELED: "canceled",
  QUALIFIED: "qualified",
  UNQUALIFIED: "unqualified",
  RESCHEDULED: "rescheduled",
  NO_SHOW: "no_show",
  PENDING: "pending",
} as const;

export const MEETING_OUTCOMES_MAP = {
  [MEETING_OUTCOMES.CANCELED]: "Meeting Canceled",
  [MEETING_OUTCOMES.QUALIFIED]: "Qualified",
  [MEETING_OUTCOMES.UNQUALIFIED]: "Unqualified",
  [MEETING_OUTCOMES.RESCHEDULED]: "Meeting Rescheduled",
  [MEETING_OUTCOMES.NO_SHOW]: "No Show",
  [MEETING_OUTCOMES.PENDING]: "Pending Feedback",
} as const;

export const MEETING_OUTCOMES_MAP_GLENX = {
  [MEETING_OUTCOMES.CANCELED]: "Meeting Canceled",
  [MEETING_OUTCOMES.QUALIFIED]: "Opportunity Created",
  [MEETING_OUTCOMES.UNQUALIFIED]: "Opportunity Not Created",
  [MEETING_OUTCOMES.RESCHEDULED]: "Meeting Rescheduled",
  [MEETING_OUTCOMES.NO_SHOW]: "No Show",
  [MEETING_OUTCOMES.PENDING]: "Pending Feedback",
} as const;

export const ACCOUNT_DETAILS_TABS = {
  ACCOUNT_HISTORY: "account-history",
  MESSAGES: "messages",
} as const;

export const ACCOUNT_STATUS_MINOR = {
  PENDING_FEEDBACK: "pending_feedback",
  UPCOMING: "upcoming",
  RESCHEDULED_UPCOMING: "rescheduled_upcoming",
  UNQUALIFIED: "unqualified",
  QUALIFIED: "qualified",
  NO_SHOW: "no_show",
  CANCELED: "cancelled",
  MORE_MATERIALS: "more_materials",
  MATERIALS_SENT: "materials_sent",
  MERGED: "merged",
  DISQUALIFIED: "disqualified",
} as const;
